import React, { useContext, useState } from "react";
import "./forgot-password.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import OTPInput from "otp-input-react"; // Import AuthContext
import AuthContext from "../../contexts/AuthContext";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { forgotPassword, verifyOTP, updatePassword, loading } = useContext(AuthContext) // Use AuthContext functions

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [step, setStep] = useState(1);
  const [pkCredentialMasterId, setPkCredentialMasterId] = useState(null);

  // Validation functions
  const validateEmail = () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePassword = () =>
    password.length >= 6 && password === confirmPassword;

  const handleSendOTP = async () => {
    if (!validateEmail()) {
      toast.error("Please enter a valid email.");
      return;
    }

    try {
      const result = await forgotPassword(email);
      if (result?.status === "Successful" && result?.code === 200) {
        toast.success("OTP sent successfully!");
        setPkCredentialMasterId(result.pkCredentialMasterId);
        setStep(2);
      } else {
        toast.error(result?.message || "User not found.");
      }
    } catch (error) {
      toast.error("Error sending OTP. Please try again.");
    }
  };

  const handleVerifyOTP = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      const result = await verifyOTP(otp);
      console.log("handleVerifyOTP result ", result)
      if (result === "OTP verified successfully!") {
        toast.success("OTP verified!");
        setStep(3);
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (error) {
      toast.error("Error verifying OTP. Try again.");
    }
  };

  const handleUpdatePassword = async () => {
    if (!validatePassword()) {
      toast.error("Passwords must match and be at least 6 characters.");
      return;
    }

    try {
      const result = await updatePassword(pkCredentialMasterId, password);
      if (result?.status === "Successful" || result?.code === 200) {
        toast.success("Password updated successfully!");
        navigate("/login");
      } else {
        toast.error("Failed to update password.");
      }
    } catch (error) {
      toast.error("Error updating password.");
    }
  };

  return (
    <>
      <main id="forgot-password" className="py-5">
        <div className="our-container">
          <div className="inner-container">
            <div className="forgot-password-block">
              <div className="forgot-password-body-block">
                {step === 1 && (
                  <div className="forgot-password-email-group mb-4">
                    <label>
                      <span className="text-danger">* </span>Sign up using Email
                    </label>
                    <div className="forgot-password-email-field mb-3">
                      <input
                        type="email"
                        placeholder="Enter your email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <button
                      onClick={handleSendOTP}
                      disabled={loading}
                      className="forgot-submit-btn mb-2"
                    >
                      {loading ? "Sending OTP..." : "Send OTP"}
                    </button>
                  </div>
                )}
                {step === 2 && (
                  <div className="otp-mobile-group mb-4">
                    <label>
                      <span className="text-danger">*</span> Enter OTP
                    </label>
                    <OTPInput
                      value={otp}
                      onChange={setOtp}
                      OTPLength={4}
                      autoFocus
                      isNumberInput
                    />
                    <button
                      onClick={handleVerifyOTP}
                      disabled={loading}
                      className="forgot-submit-btn mt-3 mb-4"
                    >
                      {loading ? "Verifying OTP..." : "Verify OTP"}
                    </button>
                  </div>
                )}
                {step === 3 && (
                  <div className="forgot-password-email-group mb-4">
                    <label>
                      <span className="text-danger">* </span>Reset Password
                    </label>
                    <div className="forgot-password-email-field mb-3">
                      <input
                        type="password"
                        placeholder="Enter new password"
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div className="forgot-password-email-field mb-3">
                      <input
                        type="password"
                        placeholder="Confirm new password"
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                    <button
                      onClick={handleUpdatePassword}
                      disabled={loading}
                      className="forgot-submit-btn mb-4"
                    >
                      {loading ? "Updating Password..." : "Update Password"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ForgotPassword;
